"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createError = exports.tryParseIsoDateString = exports.url = exports.trimStart = exports.trimEnd = exports.pad = exports.mapProperties = exports.fromJson = exports.toJson = exports.isDate = exports.isArray = exports.isFunction = exports.isBool = exports.isInteger = exports.isNumber = exports.isString = exports.isValidId = exports.isObject = exports.hasProperty = exports.has = exports.format = exports.isNullOrEmpty = exports.isNullOrZero = exports.isNull = void 0;
const Validate_1 = __importDefault(require("./Validate"));
const Platform_1 = __importDefault(require("../Platform"));
function isNull(value) {
    return value === null || value === undefined;
}
exports.isNull = isNull;
function isNullOrZero(value) {
    return value === null || value === undefined || value === 0 || value === "";
}
exports.isNullOrZero = isNullOrZero;
function isNullOrEmpty(value) {
    return isNull(value) || value.length === 0;
}
exports.isNullOrEmpty = isNullOrEmpty;
function format(message, ...args) {
    Validate_1.default.isString(message, "message");
    if (!isNullOrEmpty(message) && arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            var pattern = "{" + (i - 1) + "}";
            while (message.indexOf(pattern) !== -1) {
                message = message.replace(pattern, arguments[i]);
            }
        }
    }
    return message;
}
exports.format = format;
function has(value, key) {
    Validate_1.default.notNull(key, "key");
    Validate_1.default.isString(key, "key");
    return !isNull(value) && value.hasOwnProperty(key);
}
exports.has = has;
function hasProperty(object, properties) {
    for (var i = 0; i < properties.length; i++) {
        if (has(object, properties[i])) {
            return true;
        }
    }
    return false;
}
exports.hasProperty = hasProperty;
function isObject(value) {
    return isNull(value) || (typeof value === "object" && !isDate(value));
}
exports.isObject = isObject;
function isValidId(value) {
    if (isNullOrZero(value)) {
        return false;
    }
    if (isString(value)) {
        if (value.length === 0 || value.length > 255 || value.trim().length === 0) {
            return false;
        }
        var ex = /[+"\/?`\\]|[\u0000-\u001F]|[\u007F-\u009F]|^\.{1,2}$/;
        if (value.match(ex) !== null) {
            return false;
        }
        return true;
    }
    else if (isNumber(value)) {
        return value > 0;
    }
    return false;
}
exports.isValidId = isValidId;
function isString(value) {
    return isNull(value) || typeof value === "string";
}
exports.isString = isString;
function isNumber(value) {
    return !isNull(value) && typeof value === "number";
}
exports.isNumber = isNumber;
function isInteger(value) {
    return isNumber(value) && parseInt(value, 10) === parseFloat(value);
}
exports.isInteger = isInteger;
function isBool(value) {
    return !isNull(value) && typeof value == "boolean";
}
exports.isBool = isBool;
function isFunction(value) {
    return typeof value == "function";
}
exports.isFunction = isFunction;
function isArray(value) {
    return !isNull(value) && value.constructor === Array;
}
exports.isArray = isArray;
function classOf(value) {
    return Object.prototype.toString
        .call(value)
        .slice(8, -1)
        .toLowerCase();
}
function isDate(value) {
    return !isNull(value) && classOf(value) == "date";
}
exports.isDate = isDate;
function toJson(value) {
    return Platform_1.default.toJson(value);
}
exports.toJson = toJson;
function fromJson(value) {
    if (typeof value === "object")
        return value;
    var jsonValue = null;
    if (!isNullOrEmpty(value)) {
        jsonValue = JSON.parse(value, function (k, v) {
            if (isString(v) && !isNullOrEmpty(v)) {
                var date = tryParseIsoDateString(v);
                if (!isNull(date)) {
                    return date;
                }
            }
            return v;
        });
    }
    return jsonValue;
}
exports.fromJson = fromJson;
function mapProperties(instance, action) {
    var results = [];
    if (!isNull(instance)) {
        var key = null;
        for (key in instance) {
            results.push(action(key, instance[key]));
        }
    }
    return results;
}
exports.mapProperties = mapProperties;
function pad(value, length, ch) {
    Validate_1.default.notNull(value, "value");
    Validate_1.default.isInteger(length, "length");
    Validate_1.default.isString(ch, "ch");
    Validate_1.default.notNullOrEmpty(ch, "ch");
    Validate_1.default.length(ch, 1, "ch");
    var text = value.toString();
    while (text.length < length) {
        text = ch + text;
    }
    return text;
}
exports.pad = pad;
function trimEnd(text, ch) {
    Validate_1.default.isString(text, "text");
    Validate_1.default.notNull(text, "text");
    Validate_1.default.isString(ch, "ch");
    Validate_1.default.notNullOrEmpty("ch", "ch");
    Validate_1.default.length(ch, 1, "ch");
    var end = text.length - 1;
    while (end >= 0 && text[end] === ch) {
        end--;
    }
    return end >= 0 ? text.substr(0, end + 1) : "";
}
exports.trimEnd = trimEnd;
function trimStart(text, ch) {
    Validate_1.default.isString(text, "text");
    Validate_1.default.notNull(text, "text");
    Validate_1.default.isString(ch, "ch");
    Validate_1.default.notNullOrEmpty(ch, "ch");
    Validate_1.default.length(ch, 1, "ch");
    var start = 0;
    while (start < text.length && text[start] === ch) {
        start++;
    }
    return start < text.length ? text.substr(start, text.length - start) : "";
}
exports.trimStart = trimStart;
exports.url = {
    separator: "/",
    combinePathSegments: function () {
        var segments = [];
        var i = 0;
        Validate_1.default.notNullOrEmpty(arguments, "arguments");
        for (i = 0; i < arguments.length; i++) {
            var segment = arguments[i];
            Validate_1.default.isString(segment, format("argument[{0}]"));
            if (i !== 0) {
                segment = trimStart(segment || "", exports.url.separator);
            }
            if (i < arguments.length - 1) {
                segment = trimEnd(segment || "", exports.url.separator);
            }
            segments.push(segment);
        }
        return segments.reduce(function (a, b) {
            return a + exports.url.separator + b;
        });
    },
    getQueryString: function (parameters) {
        Validate_1.default.notNull(parameters, "parameters");
        Validate_1.default.isObject(parameters, "parameters");
        var pairs = [];
        for (var parameter in parameters) {
            var value = parameters[parameter];
            if (isObject(value)) {
                value = toJson(value);
            }
            pairs.push(encodeURIComponent(parameter) + "=" + encodeURIComponent(value));
        }
        return pairs.join("&");
    },
    combinePathAndQuery: function (path, queryString) {
        Validate_1.default.notNullOrEmpty(path, "path");
        Validate_1.default.isString(path, "path");
        if (isNullOrEmpty(queryString)) {
            return path;
        }
        Validate_1.default.isString(queryString, "queryString");
        if (path.indexOf("?") >= 0) {
            return path + "&" + trimStart(queryString, "?");
        }
        else {
            return path + "?" + trimStart(queryString, "?");
        }
    },
    isAbsoluteUrl: function (url) {
        if (isNullOrEmpty(url)) {
            return false;
        }
        var start = url.substring(0, 7).toLowerCase();
        return start == "http://" || start == "https:/";
    },
    isHttps: function (url) {
        if (isNullOrEmpty(url)) {
            return false;
        }
        var start = url.substring(0, 7).toLowerCase();
        return start == "https:/";
    }
};
function tryParseIsoDateString(text) {
    return Platform_1.default.tryParseIsoDateString(text);
}
exports.tryParseIsoDateString = tryParseIsoDateString;
function createError(exceptionOrMessage, request) {
    var error;
    if (request) {
        var message = Platform_1.default.getResourceString("Extensions_DefaultErrorMessage");
        if (request.status === 0) {
            message = Platform_1.default.getResourceString("Extensions_ConnectionFailureMessage");
        }
        else {
            var isText = false;
            if (request.getResponseHeader) {
                var contentType = request.getResponseHeader("Content-Type");
                if (contentType) {
                    isText = contentType.toLowerCase().indexOf("text") >= 0;
                }
            }
            try {
                var response = JSON.parse(request.responseText);
                if (typeof response === "string") {
                    message = response;
                }
                else {
                    message =
                        response.error ||
                            response.description ||
                            request.statusText ||
                            Platform_1.default.getResourceString("Extensions_DefaultErrorMessage");
                }
            }
            catch (ex) {
                if (isText) {
                    message = request.responseText;
                }
                else {
                    message =
                        request.statusText ||
                            Platform_1.default.getResourceString("Extensions_DefaultErrorMessage");
                }
            }
        }
        error = new Error(message);
        error.request = request;
    }
    else if (isString(exceptionOrMessage) &&
        !isNullOrEmpty(exceptionOrMessage)) {
        error = new Error(exceptionOrMessage);
    }
    else if (exceptionOrMessage instanceof Error) {
        error = exceptionOrMessage;
    }
    else {
        error = new Error(Platform_1.default.getResourceString("Extensions_DefaultErrorMessage"));
        if (!isNull(exceptionOrMessage)) {
            error.exception = exceptionOrMessage;
        }
    }
    return error;
}
exports.createError = createError;
exports.default = {
    isNull,
    isNullOrZero,
    isNullOrEmpty,
    format,
    has,
    isObject,
    isValidId,
    isString,
    isNumber,
    isInteger,
    isBool,
    isFunction,
    isArray,
    classOf,
    isDate,
    toJson,
    fromJson,
    mapProperties,
    pad,
    trimEnd,
    trimStart,
    url: exports.url,
    tryParseIsoDateString,
    createError
};
